import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";


function InlineSelectionNavbar({ darkMode, setDarkMode, activeNav = "Home" }) {
  const navigate = useNavigate();

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [accountName, setAccountName] = useState("Kids");

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}
  }, [darkMode]);

  const handleNavClick = (item) => {
    setMobileMenuOpen(false);

    if (item === "Home" || item === "Teachers" || item === "Subjects") {
      navigate("/teacher-demo");
      return;
    }

    if (item === "My Learning") {
      navigate("/profile");
    }
  };

  const themeToggle = () => {
    setDarkMode((current) => !current);
  };

  return (
    <>
      <style>{`
        .selection-navbar {
          position: sticky;
          top: 0;
          z-index: 5000;
          height: 72px;
          margin: 0 -40px 27px;
          padding: 0 48px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(180deg, #050505 0%, #080808 100%);
          border-bottom: 1px solid rgba(255,255,255,.08);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
        }

        .selection-navbar-left,
        .selection-navbar-right,
        .selection-menu,
        .selection-search-area {
          display: flex;
          align-items: center;
        }

        .selection-navbar-left { gap: 32px; min-width: 0; }
        .selection-menu { gap: 8px; }
        .selection-navbar-right { gap: 10px; }

        .selection-menu button {
          border: none;
          background: transparent;
          padding: 10px 17px;
          color: rgba(255,255,255,.68);
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          cursor: pointer;
          border-radius: 24px;
          white-space: nowrap;
          transition: .2s ease;
        }

        .selection-menu button:hover,
        .selection-menu button.active {
          background: #333338;
          color: #fff;
        }

        .selection-icon-button {
          width: 38px;
          height: 38px;
          border: none;
          border-radius: 50%;
          background: transparent;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 0;
          transition: .2s ease;
          flex-shrink: 0;
        }

        .selection-icon-button:hover,
        .selection-icon-button.active {
          background: #333338;
        }

        .selection-icon-button svg {
          width: 23px;
          height: 23px;
          display: block;
        }

        .selection-search-area { gap: 7px; }

        .selection-search-input {
          width: 220px;
          height: 36px;
          border: 1px solid rgba(255,255,255,.25);
          border-radius: 5px;
          outline: none;
          background: #181818;
          color: #fff;
          padding: 0 11px;
          font-size: 14px;
        }

        .selection-search-input::placeholder { color: rgba(255,255,255,.5); }

        .selection-kids-item {
          height: 38px;
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 0 6px;
          border: none;
          border-radius: 6px;
          background: transparent;
          color: #fff;
          cursor: pointer;
        }

        .selection-kids-item:hover { background: #333338; }

        .selection-kids-logo {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: linear-gradient(135deg,#8d42b9 0%,#d34f9d 48%,#f3b33d 48%,#f3b33d 100%);
        }

        .selection-kids-logo span {
          color: #fff;
          font-size: 9px;
          font-weight: 800;
          background: rgba(220,60,170,.75);
          padding: 2px 1px;
        }

        .selection-kids-text { font-size: 16px; font-weight: 500; }
        .selection-kids-arrow { width: 9px; height: 9px; }

        .selection-profile {
          display: flex;
          align-items: center;
          gap: 3px;
        }

        .selection-profile-icon {
          width: 38px;
          height: 38px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f2c900;
          color: #fff;
          cursor: pointer;
          border: none;
        }

        .selection-profile-icon svg { width: 24px; height: 24px; }
        .selection-profile-arrow { width: 10px; height: 10px; color: #aaa; }

        .selection-mobile-button { display:none; }

        .selection-mobile-panel {
          position: fixed;
          top: 72px;
          left: 12px;
          right: 12px;
          z-index: 4999;
          padding: 8px;
          border-radius: 8px;
          background: #181818;
          border: 1px solid rgba(255,255,255,.12);
          box-shadow: 0 15px 40px rgba(0,0,0,.65);
        }

        .selection-mobile-panel button {
          width:100%;
          height:44px;
          border:0;
          border-radius:6px;
          background:transparent;
          color:#ddd;
          text-align:left;
          padding:0 14px;
          font-size:15px;
          cursor:pointer;
        }

        .selection-mobile-panel button:hover,
        .selection-mobile-panel button.active {
          background:#333338;
          color:#fff;
        }

        .light-mode .selection-navbar {
          background: #fff;
          border-bottom-color: rgba(0,0,0,.10);
          box-shadow: 0 1px 8px rgba(0,0,0,.06);
        }

        .light-mode .selection-menu button { color: rgba(0,0,0,.68); }

        .light-mode .selection-menu button:hover,
        .light-mode .selection-menu button.active {
          background:#e7e7e7;
          color:#111;
        }

        .light-mode .selection-icon-button,
        .light-mode .selection-kids-item { color:#111; }

        .light-mode .selection-icon-button:hover,
        .light-mode .selection-icon-button.active,
        .light-mode .selection-kids-item:hover { background:#eeeeee; }

        .light-mode .selection-search-input {
          background:#f7f7f7;
          color:#111;
          border-color:rgba(0,0,0,.16);
        }

        .light-mode .selection-search-input::placeholder { color:rgba(0,0,0,.45); }

        .light-mode .selection-mobile-panel {
          background:#fff;
          border-color:rgba(0,0,0,.12);
          box-shadow:0 15px 40px rgba(0,0,0,.18);
        }

        .light-mode .selection-mobile-panel button { color:#333; }

        .light-mode .selection-mobile-panel button:hover,
        .light-mode .selection-mobile-panel button.active {
          background:#e8e8e8;
          color:#111;
        }

        @media (max-width: 900px) {
          .selection-navbar {
            padding:0 25px;
            margin-left:-25px;
            margin-right:-25px;
          }

          .selection-menu { gap:2px; }
          .selection-menu button { padding:10px; font-size:14px; }
        }

        @media (max-width: 768px) {
          .selection-navbar {
            height:72px;
            margin:0 -20px 25px;
            padding:0 20px;
          }

          .selection-menu { display:none; }
          .selection-mobile-button { display:flex; }
          .selection-navbar-right { gap:5px; }
          .selection-kids-text,
          .selection-profile-arrow { display:none; }

          .selection-search-input {
            position:absolute;
            right:105px;
            top:18px;
            width:170px;
          }
        }
      `}</style>

      <nav className="selection-navbar">
        <div className="selection-navbar-left">
          <button
            type="button"
            className="selection-icon-button selection-mobile-button"
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label="Menu"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>

          <div className="selection-menu">
            {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
              <button
                key={item}
                type="button"
                className={activeNav === item ? "active" : ""}
                onClick={() => handleNavClick(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="selection-navbar-right">
          <button
            type="button"
            className="selection-icon-button"
            onClick={themeToggle}
            aria-label="Toggle theme"
          >
            {darkMode ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z" />
              </svg>
            )}
          </button>

          <div className="selection-search-area">
            {searchOpen && (
              <input
                className="selection-search-input"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search..."
                autoFocus
              />
            )}

            <button
              type="button"
              className={`selection-icon-button ${searchOpen ? "active" : ""}`}
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="Search"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                <circle cx="10.8" cy="10.8" r="6.8" />
                <path d="m16 16 5 5" />
              </svg>
            </button>
          </div>

          <button type="button" className="selection-icon-button" aria-label="Notifications">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
              <path d="M10 21h4" />
            </svg>
          </button>

          <button
            type="button"
            className="selection-kids-item"
            onClick={() => setAccountName((current) => current === "Kids" ? "Kids" : "Kids")}
          >
            <span className="selection-kids-logo"><span>kids</span></span>
            <span className="selection-kids-text">{accountName}</span>
            <svg className="selection-kids-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </button>

          <div className="selection-profile">
            <button
              type="button"
              className="selection-profile-icon"
              onClick={() => navigate("/profile")}
              aria-label="Profile"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="8" cy="8" r="2.2" />
                <circle cx="16" cy="8" r="2.2" />
                <path d="M6 14c1.2 1.5 3.2 2.3 6 2.3s4.8-.8 6-2.3" />
              </svg>
            </button>
            <svg className="selection-profile-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="selection-mobile-panel">
          {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
            <button
              key={item}
              type="button"
              className={activeNav === item ? "active" : ""}
              onClick={() => handleNavClick(item)}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </>
  );
}


function SubjectSelection() {

  const navigate = useNavigate();

  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("teacher_demo_theme") !== "light";
    } catch (error) {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}

    document.body.style.backgroundColor = darkMode ? "#141414" : "#ffffff";
    document.documentElement.style.backgroundColor = darkMode ? "#141414" : "#ffffff";

    return () => {
      document.body.style.backgroundColor = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, [darkMode]);
  const { gradeId } = useParams();

  // -----------------------------------------------------
  // FLOW 2
  // Teacher is selected first, so teacher_id is carried
  // through Grade -> Subject -> Module -> MCQ.
  //
  // Example:
  // /subject-selection/200001?teacher_id=700001
  // -----------------------------------------------------
  const [searchParams] = useSearchParams();

  const teacherId = searchParams.get("teacher_id");

  // =====================================================
  // FLOW 3
  // Subject -> Grade -> Module -> Teacher -> MCQ
  // =====================================================
  const subjectFirstFlow =
    searchParams.get("flow") === "subject-first";

  const subjectFirstId =
    searchParams.get("subject_id");

  const subjectFirstName =
    searchParams.get("subject_name") || "";

  const [gradeName, setGradeName] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [streams, setStreams] = useState([]);
  const [selectedStream, setSelectedStream] = useState("");
  const [loading, setLoading] = useState(true);
  const [streamLoading, setStreamLoading] = useState(false);
  const [error, setError] = useState("");

  const SUBJECT_API =
    "https://edunet.kmechengineering.com/root-engine1/api/subject-by-grade";

  const STREAM_API =
    "https://edunet.kmechengineering.com/root-engine1/api/streams-by-grade";

  const SUBJECT_STREAM_API =
    "https://edunet.kmechengineering.com/root-engine1/api/subjects-by-stream";

  // =====================================================
  // LOAD SUBJECTS + STREAMS
  // =====================================================

  useEffect(() => {

    const loadData = async () => {

      setLoading(true);
      setError("");

      try {

        // -------------------------------------------------
        // FLOW 3
        // Subject -> Grade
        //
        // We already know the selected subject, so instead
        // of loading subjects for one grade, load all grades
        // and keep only the grades where this subject exists.
        // -------------------------------------------------
        if (subjectFirstFlow && subjectFirstId) {

          const gradesResponse = await fetch(
            "https://edunet.kmechengineering.com/root-engine1/api/grades"
          );

          if (!gradesResponse.ok) {
            throw new Error("Failed to load grades");
          }

          const gradesData = await gradesResponse.json();

          const allGrades =
            gradesData.grade_data || [];

          const gradeResults = await Promise.all(
            allGrades.map(async (grade) => {

              const currentGradeId =
                grade.grade_id ??
                grade.gradeId ??
                grade.id ??
                null;

              if (!currentGradeId) {
                return null;
              }

              try {

                const response = await fetch(
                  `${SUBJECT_API}?grade_id=${encodeURIComponent(
                    currentGradeId
                  )}`
                );

                if (!response.ok) {
                  return null;
                }

                const data = await response.json();

                const gradeSubjects =
                  data.subject_data || [];

                const matchingSubject =
                  gradeSubjects.find((item) => {

                    const itemId =
                      item.subject_id ??
                      item.id ??
                      item.subjectId ??
                      null;

                    return (
                      String(itemId) ===
                      String(subjectFirstId)
                    );
                  });

                if (!matchingSubject) {
                  return null;
                }

                return {
                  grade_id: currentGradeId,
                  grade_name:
                    grade.name ||
                    grade.grade_name ||
                    grade.grade ||
                    grade.title ||
                    data.grade_name ||
                    `Grade ${currentGradeId}`
                };

              } catch (gradeError) {

                console.error(
                  "Grade subject check failed:",
                  currentGradeId,
                  gradeError
                );

                return null;
              }

            })
          );

          const availableGrades =
            gradeResults.filter(Boolean);

          // Reuse the existing subjects state to store
          // the selected subject information.
          setGradeName(subjectFirstName || "Grades");
          setSubjects([
            {
              subject_id: subjectFirstId,
              name: subjectFirstName,
              grades: availableGrades
            }
          ]);

          setStreams([]);

          return;
        }

        // -------------------------------------------------
        // FLOW 1 + FLOW 2
        // Existing Grade -> Subject behaviour remains
        // unchanged.
        // -------------------------------------------------

        const subjectResponse = await fetch(
          `${SUBJECT_API}?grade_id=${encodeURIComponent(gradeId)}`
        );

        if (!subjectResponse.ok) {
          throw new Error("Failed to load subjects");
        }

        const subjectData = await subjectResponse.json();

        setGradeName(subjectData.grade_name || "");
        setSubjects(subjectData.subject_data || []);

        // Grade 12 / 13 can have streams.
        // For other grades the API can return an empty stream list.
        const streamResponse = await fetch(
          `${STREAM_API}?grade_id=${encodeURIComponent(gradeId)}`
        );

        if (streamResponse.ok) {

          const streamData = await streamResponse.json();

          setStreams(streamData.stream_data || []);

        } else {

          setStreams([]);

        }

      } catch (error) {

        console.error("Subject API Error:", error);

        setSubjects([]);
        setStreams([]);
        setError(
          subjectFirstFlow
            ? "Unable to load grades for this subject."
            : "Unable to load subjects."
        );

      } finally {

        setLoading(false);

      }

    };

    if (subjectFirstFlow) {
      if (subjectFirstId) {
        loadData();
      } else {
        setLoading(false);
        setError("Subject ID is missing.");
      }

      return;
    }

    if (gradeId) {
      loadData();
    }

  }, [
    gradeId,
    subjectFirstFlow,
    subjectFirstId,
    subjectFirstName
  ]);

  // =====================================================
  // LOAD SUBJECTS BY STREAM
  // =====================================================

  const handleStreamSelect = async (streamName) => {

    setSelectedStream(streamName);
    setStreamLoading(true);
    setError("");

    try {

      const response = await fetch(
        `${SUBJECT_STREAM_API}?grade_id=${encodeURIComponent(
          gradeId
        )}&stream_name=${encodeURIComponent(streamName)}`
      );

      if (!response.ok) {
        throw new Error("Failed to load stream subjects");
      }

      const data = await response.json();

      setSubjects(data.subject_data || []);

    } catch (error) {

      console.error("Stream Subject API Error:", error);

      setSubjects([]);
      setError("Unable to load subjects for this stream.");

    } finally {

      setStreamLoading(false);

    }

  };

  const getSubjectName = (subject) => {

    return (
      subject.name ||
      subject.subject_name ||
      subject.title ||
      `Subject ${subject.id || subject.subject_id || ""}`
    );

  };

  const getSubjectId = (subject) => {

    return (
      subject.subject_id ??
      subject.id ??
      subject.subjectId ??
      null
    );

  };

  // =====================================================
  // PAGE
  // =====================================================

  return (

    <div className={`subject-selection-page ${darkMode ? "dark-mode" : "light-mode"}`} >

      <style>{`

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          background: #141414;
        }

        .subject-selection-page {
          min-height: 100vh;
          background:
            linear-gradient(
              180deg,
              #050505 0%,
              #141414 30%,
              #141414 100%
            );
          color: #fff;
          padding-bottom: 70px;
          font-family:
            Arial,
            Helvetica,
            sans-serif;
        }

        .subject-page-content {
          padding: 42px 40px 0;
        }

        .subject-title {
          font-size: 30px;
          font-weight: 700;
          margin: 0 0 7px;
        }

        .subject-subtitle {
          margin: 0 0 25px;
          color: rgba(255,255,255,.58);
          font-size: 14px;
        }

        .subject-back {
          border: none;
          background: transparent;
          color: rgba(255,255,255,.72);
          padding: 0;
          margin: 0 0 24px;
          cursor: pointer;
          font-size: 14px;
        }

        .subject-back:hover {
          color: #fff;
        }

        .section-title {
          font-size: 19px;
          font-weight: 700;
          margin: 0 0 14px;
        }

        .stream-row,
        .subject-row {
          display: grid;
          grid-template-columns:
            repeat(
              auto-fit,
              minmax(220px, 1fr)
            );
          gap: 14px;
          width: 100%;
        }

        .stream-card,
        .subject-card {
          min-height: 125px;
          border-radius: 7px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          border: 1px solid rgba(255,255,255,.05);
          background:
            linear-gradient(
              135deg,
              #252525,
              #111
            );
          transition:
            transform .25s ease,
            box-shadow .25s ease,
            border-color .25s ease;
        }

        .stream-card:hover,
        .subject-card:hover {
          transform: scale(1.035);
          box-shadow:
            0 15px 40px
            rgba(0,0,0,.65);
          border-color:
            rgba(255,255,255,.14);
        }

        .stream-card::after,
        .subject-card::after {
          content: "";
          position: absolute;
          inset: 0;
          background:
            linear-gradient(
              180deg,
              transparent 20%,
              rgba(0,0,0,.9) 100%
            );
        }

        .stream-number,
        .subject-number {
          position: absolute;
          top: 15px;
          left: 17px;
          z-index: 5;
          font-size: 12px;
          color: rgba(255,255,255,.58);
        }

        .stream-name,
        .subject-name {
          position: absolute;
          left: 17px;
          right: 17px;
          bottom: 17px;
          z-index: 5;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
        }

        .stream-active {
          border-color: #6f62ff;
          box-shadow:
            0 0 0 1px
            rgba(111,98,255,.35);
        }

        .subject-section {
          margin-top: 30px;
        }

        .loading,
        .empty,
        .error {
          padding: 45px 0;
          color: #999;
          font-size: 14px;
        }

        .error {
          color: #ff7777;
        }


        /* =================================================
           LIGHT MODE
        ================================================= */

        .subject-selection-page.light-mode {
          background: #ffffff;
          color: #111;
        }

        .light-mode .subject-title { color: #111; }
        .light-mode .subject-subtitle { color: rgba(0,0,0,.58); }
        .light-mode .section-title { color: #111; }
        .light-mode .subject-back { color: rgba(0,0,0,.68); }
        .light-mode .subject-back:hover { color: #111; }

        .light-mode .subject-card {
          background: linear-gradient(135deg, #f3f3f3, #dedede);
          border-color: rgba(0,0,0,.08);
          box-shadow: 0 8px 24px rgba(0,0,0,.05);
        }

        .light-mode .subject-card::after {
          background: linear-gradient(180deg, transparent 20%, rgba(0,0,0,.12) 100%);
        }

        .light-mode .subject-number { color: rgba(0,0,0,.52); }
        .light-mode .subject-name { color: #111; }

        .light-mode .loading,
        .light-mode .empty,
        .light-mode .error { color: #666; }

        @media(max-width:768px) {

          .subject-page-content {
            padding: 30px 20px 0;
          }

          .subject-title {
            font-size: 25px;
          }

          .stream-row,
          .subject-row {
            grid-template-columns: 1fr;
          }

        }

      `}</style>

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <InlineSelectionNavbar darkMode={darkMode} setDarkMode={setDarkMode} activeNav="Home" />

      <main className="subject-page-content">

        <button
          className="subject-back"
          onClick={() => navigate(-1)}
        >
          {subjectFirstFlow
            ? "← Back to Subjects"
            : "← Back to Grades"}
        </button>

        <h1 className="subject-title">
          {subjectFirstFlow
            ? subjectFirstName || "Grades"
            : gradeName || "Subjects"}
        </h1>

        <p className="subject-subtitle">
          {subjectFirstFlow
            ? "Select a grade to continue learning"
            : "Select a subject to continue learning"}
        </p>

        {loading ? (

          <div className="loading">
            Loading subjects...
          </div>

        ) : error ? (

          <div className="error">
            {error}
          </div>

        ) : (

          <>
            {subjectFirstFlow ? (

              <section className="subject-section">

                <h2 className="section-title">
                  Grades
                </h2>

                {subjects.length === 0 ||
                 !subjects[0]?.grades?.length ? (

                  <div className="empty">
                    No grades available for this subject.
                  </div>

                ) : (

                  <div className="subject-row">

                    {subjects[0].grades.map((grade, index) => (

                      <div
                        key={grade.grade_id}
                        className="subject-card"
                        onClick={() => {

                          const currentGradeId =
                            grade.grade_id;

                          if (!currentGradeId) {
                            console.error(
                              "Grade ID is missing:",
                              grade
                            );
                            return;
                          }

                          // -------------------------------------------------
                          // FLOW 3 - STEP 2
                          // Subject -> Grade -> Module
                          //
                          // Existing ModuleSelection.jsx is reused.
                          // The selected subject is carried in the URL.
                          // -------------------------------------------------
                          navigate(
                            `/module-selection/${encodeURIComponent(
                              currentGradeId
                            )}/${encodeURIComponent(
                              subjectFirstId
                            )}?flow=subject-first`
                          );

                        }}
                      >

                        <div className="subject-number">
                          {String(index + 1).padStart(2, "0")}
                        </div>

                        <div className="subject-name">
                          {grade.grade_name}
                        </div>

                      </div>

                    ))}

                  </div>

                )}

              </section>

            ) : (

              <>
                {streams.length > 0 && (

                  <section>

                    <h2 className="section-title">
                      Select Stream
                    </h2>

                    <div className="stream-row">

                      {streams.map((stream, index) => {

                        const streamName =
                          stream.stream_name ||
                          stream.name ||
                          stream.title;

                        return (

                          <div
                            key={`${streamName}-${index}`}
                            className={
                              `stream-card ${
                                selectedStream === streamName
                                  ? "stream-active"
                                  : ""
                              }`
                            }
                            onClick={() =>
                              handleStreamSelect(streamName)
                            }
                          >

                            <div className="stream-number">
                              {String(index + 1).padStart(2, "0")}
                            </div>

                            <div className="stream-name">
                              {streamName}
                            </div>

                          </div>

                        );

                      })}

                    </div>

                  </section>

                )}

                <section className="subject-section">

                  <h2 className="section-title">
                    Subjects
                  </h2>

                  {streamLoading ? (

                    <div className="loading">
                      Loading subjects...
                    </div>

                  ) : subjects.length === 0 ? (

                    <div className="empty">
                      No subjects available.
                    </div>

                  ) : (

                    <div className="subject-row">

                      {subjects.map((subject, index) => (

                        <div
                          key={getSubjectId(subject, index)}
                          className="subject-card"
                          onClick={() => {

                            const selectedSubjectId =
                              getSubjectId(subject, index);

                            if (!selectedSubjectId) {
                              console.error(
                                "Subject ID is missing:",
                                subject
                              );
                              return;
                            }

                            const modulePath =
                              `/module-selection/${encodeURIComponent(
                                gradeId
                              )}/${encodeURIComponent(
                                selectedSubjectId
                              )}`;

                            // Existing Flow 2
                            if (teacherId) {
                              navigate(
                                `${modulePath}?teacher_id=${encodeURIComponent(
                                  teacherId
                                )}`
                              );

                              return;
                            }

                            // Existing Flow 1
                            navigate(modulePath);

                          }}
                        >

                          <div className="subject-number">
                            {String(index + 1).padStart(2, "0")}
                          </div>

                          <div className="subject-name">
                            {getSubjectName(subject)}
                          </div>

                        </div>

                      ))}

                    </div>

                  )}

                </section>
              </>

            )}
          </>

        )}

      </main>

    </div>

  );

}

export default SubjectSelection;


